import gql from 'graphql-tag'

export default gql`
  mutation prepareEsign(
    $input: PrepareEsignInput!
    # $documentId:       Int!,
    # $documentType:     String!,
    # $requestMethod:    String,
    # $signers:          [EsignSigners!]!,
    # $file:             Upload!,
  ) {
    prepareEsign(
      input: $input
      # input: {
      #   documentId:       $documentId,
      #   documentType:     $documentType,
      #   requestMethod:    $requestMethod,
      #   signers:          $signers,
      #   file:             $file
      # }
    ) {
      helloSign {
        claimUrl
      }
    }
  }
`
